import { createStyles } from '@mantine/core';
import Banner from '../../../assets/images/editlistBanner.png';
import {body_min_height} from "../../../utils/const.js"
export const useStyles = createStyles((theme) => ({
  wrapper: {
    background: 'rgb(224,244,245,0.5)',
    paddingBottom: 100,
    paddingTop: 50,
    backgroundImage: `url(${Banner})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    [theme.fn.smallerThan(800)]: {
      backgroundImage: 'none',
      paddingTop: 35
    },
    [theme.fn.largerThan(786)]: {
        minHeight:`${body_min_height.desktop} !important`
     },
     '.no-record-found':{
       display: 'none !important'
     }
  },
  tableContainer: {
    width: '80%',
    margin: 'auto',
    [theme.fn.smallerThan(1400)]: {
      width: '90%'
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%',
      overflowX: 'scroll'
    }
  },
  table: {
    backgroundColor: theme.colors.background[0],
    width: '100%',
    margin: 'auto',
    marginTop: 20,
    marginBlock: 20,
    borderRadius: 10,
    [theme.fn.smallerThan(1050)]: {
      width: 1200
    },
    [theme.fn.smallerThan(800)]: {
      width: 800
    }
  },
  headerAndSearch: {
    width: '80%',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.fn.smallerThan(1400)]: {
      width: '90%'
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%'
    },
    [theme.fn.smallerThan(800)]: {
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: 20,
      padding: 10
    }
  },
  searchAndFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 20,

    [theme.fn.smallerThan(800)]: {
      width: '100%',
      marginTop: 10
    }
  },

  searchIcon: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 99,
    width: 16,
    height: 16
  },
  searchInput: {
    width: 472,
    border: 'none !important',
    [theme.fn.smallerThan(800)]: {
      width: 300,
      height: 48
    },
    input: {
      border: 'none',
      borderRadius: 16,
      fontSize: 16,
      color: theme.colors.text[1],
      fontFamily: `Regular, ${theme.fontFamily}`,
      height: 50,
      [theme.fn.smallerThan(800)]: {
        fontSize: 16,
        height: 50
      }
    }
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10,
    background: 'white',
    borderRadius: 16,
    paddingLeft: 10,
    paddingRight: 10,
    height: 48,
    width: 111,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.fn.smallerThan(500)]: {
      width: 35,
      height: 35,
      borderRadius: 10
    },
    [theme.fn.smallerThan(800)]: {
      width: 48,
      height: 48,
      borderRadius: 16,
      justifyContent: 'center'
    }
  },

  link: {
    textDecoration: 'none',
    [theme.fn.smallerThan(800)]: {
      display: 'none'
    }
  },
  linkMobile: {
    textDecoration: 'none',
    [theme.fn.smallerThan(800)]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  filterIcon: {
    width: 12,
    height: 12
  },
  filter: {
    fontFamily: `Regular, ${theme.fontFamily}`,
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: '0.15px',
    fontWeight: 400,
    color: theme.colors.text[1],

    [theme.fn.smallerThan(500)]: {
      display: 'none'
    }
  },

  title: {
    fontFamily: `Medium, ${theme.fontFamily}`,
    fontSize: 26,
    fontWeight: 500,
    color: theme.colors.secondary[0]
  },
  noRecordtitle: {
    fontFamily: `Medium, ${theme.fontFamily}`,
    fontSize: 26,
    fontWeight: 500,
    color: theme.colors.secondary[0],
    [theme.fn.smallerThan(500)]: {
      fontSize: 20
    }
  },
  tableHead: {
    backgroundColor: theme.colors.secondary[0],
    height: 50
  },
  columnHeading: {
    color: 'white !important',
    fontFamily: `SemiBold, ${theme.fontFamily}`,
    letterSpacing: 0.15,
    fontSize: '13px !important',
    fontWeight: 600,
    lineHeight: '24px',
    ':first-child': {
      borderTopLeftRadius: 10,
      paddingLeft: 25
    },
    ':last-child': {
      borderTopRightRadius: 10
    }
  },
  tableRowWhite: {
    height: 70,
    background: 'white',
    border: 'none'
  },
  tableRow: {
    height: 70,
    background: '#F1F6F6',
    border: 'none'
  },
  noRecordTableRow:{
    textAlign:'center',
    border: 'none',
  },
  tableData: {
    borderTop: 'none !important',
    fontFamily: `Regular , ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 16,
    ':first-child': {
      paddingLeft: 25,
      width: 467,
      [theme.fn.smallerThan(800)]: {
        width: 257,
        flex: '0 0 auto'
      }
    },
    ':nth-child(2)': {
      flex: '0 0 auto',
      width: 380,
      [theme.fn.smallerThan(800)]: {
        width: 257,
        flex: '0 0 auto'
      }
    },
    ':nth-child(3)': {
      flex: '0 0 auto',
      width: 250,
      [theme.fn.smallerThan(1800)]: {
        width: 200,
        flex: '0 0 auto'
      },
      [theme.fn.smallerThan(800)]: {
        width: 112,
        flex: '0 0 auto'
      }
    },
    ':nth-child(4)': {
      flex: '0 0 auto',
      width: 250,
      [theme.fn.smallerThan(1800)]: {
        width: 250,
        flex: '0 0 auto'
      },
      [theme.fn.smallerThan(800)]: {
        width: 200,
        flex: '0 0 auto'
      }
    },
    ':last-child': {
      flex: '0 0 auto',
      width: 150,
      [theme.fn.smallerThan(800)]: {
        width: 120,
        flex: '0 0 auto'
      }
    }
  },
  privateText: {
    borderTop: 'none !important',
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    color: theme.colors.secondary[0],
    fontWeight: 600,
    letterSpacing: '0.15px',
    fontSize: 16
  },
  editAndView: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'left',
    columnGap: 35
  },
  action: {
    width: 20,
    height: 20,
    cursor: 'pointer'
  },
  status: {
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    fontWeight: 600,
    width: 140,
    textAlign: 'center',
    padding: 8,
    fontSize: 12,
    borderRadius: 10,
    letterSpacing: '0.25px'
  },
  active: {
    background: theme.colors.background[4],
    color: '#64B216'
  },
  inactive: {
    background: '#F5DBDB',
    color: theme.colors.text[5]
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    border: 'none !important',
    marginTop: 50,
    button: {
      border: 'none !important',
      backgroundColor: 'transparent'
    }
  },
  payBtn: {
    display: 'flex',
    padding: '8px 40px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  },
  dueTitle: {
    color: theme.colors.primary[0]
  },
  noDue: {
    width:'100%'
  },
  loader: {
    position:'fixed',
    top: '50%',
    left: '48%',
    zIndex: '1000',

    [theme.fn.largerThan('xs')]: {
      left: '48%',

    }
  }
}));
